import Container from '@material-ui/core/Container';
import styled from 'styled-components';
import { Colors } from '../utils/colors';

export const TheContainer = styled(Container)`
  max-width: 300px;
  padding: 20px;
  background-color: ${Colors.backgroundEggshell};
`;
